module.exports = __webpack_public_path__ + "static/media/slide1.0446e089.jpg";